import { ISelectOptions, ISelectOption } from "react-ocean-forms-bootstrap";
import { ViewMode } from "../components/Common/ViewMode";
import { Status } from "./model";

/**
 * @author jungwirth
 */
export abstract class IStatusUtil {

  /**
   * 
   * @param status 
   */
  getStatusOption(status: Status): ISelectOption {
    return {label: status.name, value: status.id};
  }

  abstract getStatusEnumFromStatus(id: string): any;
  
  /**
   * 
   * @param role 
   * @param view 
   * @param selected 
   */
  abstract getStatusList(role: string, view: ViewMode, selected?: ISelectOption): ISelectOptions;
}
